@import './ionic-selectable-modal.component';
@import './ionic-selectable-modal.md.vars.component';

// Material Design ionic-selectable-modal
// --------------------------------------------------
